import { Box, Typography } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

import { FORTA_ORANGE, FORTA_WHITE } from '../../utils/colors';

interface IFHWarningProps {
  sxContainer?: any;
  sxText?: any;
  iconColor?: string;
  hideIcon?: boolean;
  content: string;
  bold?: boolean;
  showInfoIcon?: boolean;
}

function FHWarning({
  content,
  iconColor,
  showInfoIcon = false,
  sxContainer = {},
  sxText = {},
  bold = false,
  hideIcon = false,
}: IFHWarningProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        p: 1,
        pr: 1.5,
        width: 'fit-content',
        borderRadius: '8px',
        backgroundColor: FORTA_WHITE,
        ...sxContainer,
      }}
    >
      {!hideIcon && !showInfoIcon && (
        <WarningAmberRoundedIcon
          sx={{ color: iconColor ? iconColor : FORTA_ORANGE, width: 27, height: 27, mt: -0.2 }}
        />
      )}
      {!hideIcon && showInfoIcon && (
        <ErrorOutlineOutlinedIcon
          sx={{ color: iconColor ? iconColor : FORTA_ORANGE, width: 27, height: 27, mt: -0.2 }}
        />
      )}
      <Typography
        ml={0.5}
        textAlign="left"
        sx={{ fontSize: '14px', width: 'fit-content', fontWeight: bold ? 700 : 400, ...sxText }}
      >
        {content}
      </Typography>
    </Box>
  );
}

export default FHWarning;
